/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicRecoveryConfiguration extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicRecoveryConfiguration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicRecoveryConfiguration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicRecoveryConfiguration>): BackgroundJobPayloadForPeriodicRecoveryConfiguration {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicRecoveryConfiguration(), model);
        BackgroundJobPayloadForPeriodicRecoveryConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicRecoveryConfiguration>): BackgroundJobPayloadForPeriodicRecoveryConfiguration {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicRecoveryConfiguration.newInstance(<BackgroundJobPayloadForPeriodicRecoveryConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicRecoveryConfiguration) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicRecoveryConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicRecoveryConfiguration): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicRecoveryConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
